import React from 'react'

import { WithDefaultProps } from 'browser/components/atomic-elements/higher-order-components/with-default-props'
import { EntityPage } from './entity-page'

export const EntityIndex = EntityPage
export const EntitySinglePage = WithDefaultProps(EntityPage, {
  isFullScreen: true,
})
